import type { components, paths } from '@/types/hypervision_schema'
import { defineStore } from 'pinia'
import createClient from 'openapi-fetch'
import { useSecurityStore } from './store_security'

type ChartBuilderStoreState = {
  units: components['schemas']['Unit'][]
}

const client = createClient<paths>({
  baseUrl: '/api'
})

export const useUnitStore = defineStore('unit', {
  state: (): ChartBuilderStoreState => ({
    units: []
  }),
  getters: {
    getUnit: (state) => {
      return (id: string) => {
        for (const unit of state.units) {
          if (unit.unitId === id) {
            return unit
          }
        }
      }
    }
  },
  actions: {
    async fetch() {
      const security_store = useSecurityStore()
      const request = client.GET('/api/Units', {
        headers: {
          Authorization: `Bearer ${security_store.getJWT}`
        }
      })

      request.then((response) => {
        if (response.data) {
          this.units = response.data
        }
      })

      return request
    }
  }
})
